import * as types from "../constants/actionTypes";
// import * as auth from "../tools/auth0.cred";
import * as api from "../tools/apiConfig";
// import jQuery from "jquery";
import axios from "axios";
// import { props.history } from "../store/configureStore";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export function uploadDocument(data, props) {
  
  return function(dispatch, getState) {
    var formData = new FormData();
    formData.append("file", data.file);
    formData.append("appointmentId", data.appointmentId);
    formData.append("patientId", data.patientId);
    formData.append("documentName", data.documentName);
    formData.append("documentTypeId", data.documentTypeId);
    axios
      .post(api.UPLOAD_APPOINTMENT_DOCUMENT, formData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.token
        }
      })
      .then(function(response) {
        if (response.data.code == 200) {
          let objectDocument = {
            appointmentId: data.appointmentId
          };
          axios
            .post(api.GET_APPOINTMENT_DOCUMENT, objectDocument, {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + localStorage.token
              }
            })
            .then(function(response) {
              if (response.data.code == 200) {
                return dispatch({
                  type: types.GET_APPOINTMENT_DOCUMENT,
                  uploadedImages: response.data.data
                });
              } else if (response.data.code == 402) {
                localStorage.clear();
                props.history.push("/");
                toastr.error(response.data.message);
              }
            })
            .catch(function(error) {});
        } else {
          
        }
      })
      .catch(function(error) {});
  };
}

export function getDocumentType(data, props) {
  return function(dispatch, getState) {
    axios
      .post(api.GET_DOCUMENT_TYPE, data, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.token
        }
      })
      .then(function(response) {
        if (response.data.code == 200) {
          return dispatch({
            type: types.GET_DOCUMENT_TYPE,
            userTypeData: response.data.data
          });
        } else if (response.data.code == 402) {
          localStorage.clear();
          props.history.push("/");
          toastr.error(response.data.message);
        }
      })
      .catch(function(error) {});
  };
}

export function getAllDocumentTypes(data, props) {
  return function(dispatch, getState) {
    axios
      .post(api.GET_ALL_DOCUMENT_TYPES, data, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.token
        }
      })
      .then(function(response) {
        if (response.data.code == 200) {
          console.log('hi',response.data)
          return dispatch({
            type: types.GET_ALL_DOCUMENT_TYPES,
						docTypes: response.data.data,
						doclength:response.data.data.docs.length
          });
        } else if (response.data.code == 402) {
          localStorage.clear();
          props.history.push("/");
          toastr.error(response.data.message);
        }
      })
      .catch(function(error) {});
  };
}

export function getAppointmentDocument(data, props) {
  return function(dispatch, getState) {
    axios
      .post(api.GET_APPOINTMENT_DOCUMENT, data, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.token
        }
      })
      .then(function(response) {
        if (response.data.code == 200) {
          return dispatch({
            type: types.GET_APPOINTMENT_DOCUMENT,
            uploadedImages: response.data.data
          });
        } else if (response.data.code == 402) {
          localStorage.clear();
          props.props.history.push("/");
          toastr.error(response.data.message);
        }
      })
      .catch(function(error) {});
  };
}

export function deleteDocument(appointmentId, documentId) {
  return function(dispatch, getState) {
    var data = {
      documentId: documentId
    };
    axios
      .post(
        api.DELETE_DOCUMENT,
        { documentId: documentId },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.token
          }
        }
      )
      .then(function(response) {
        if (response.data.code == 200) {
          var objectDocument = {
            appointmentId: appointmentId
          };
          axios
            .post(api.GET_APPOINTMENT_DOCUMENT, objectDocument, {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + localStorage.token
              }
            })
            .then(function(response) {
              if (response.data.code == 200) {
                return dispatch({
                  type: types.GET_APPOINTMENT_DOCUMENT,
                  uploadedImages: response.data.data
                });
              } else if (response.data.code == 402) {
                localStorage.clear();
                props.history.push("/");
                toastr.error(response.data.message);
              }
            })
            .catch(function(error) {});
        } else {
        }
      })
      .catch(function(error) {});
  };
}

export function uploadSpecialistDocument(data) {
  
  return function(dispatch, getState) {
   
   
    let success = false
    var ResponseMsg = ""


    console.log(data)
    for(let i = 0; i< data.file.length; i++){

      
      var formData = new FormData();
      formData.append("file", data.file[i]);
      formData.append("userId", data.userId);
      formData.append("documentName", data.documentName);
      formData.append("documentTypeId", data.documentTypeId);
      formData.append("docTypeId", data.docTypeId);
      console.log(formData)
      axios.post(api.UPLOAD_SPECIALIST_DOCUMENT, formData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.token
        }
      })
      .then(function(response) {
        console.log(response)
        if (response.data.code == 200) {
        
          ResponseMsg = response.data.message
          response.data.data.success = true;
          // props.history.push("/specialist/my-documents");
          if(i=== (data.file.length-1)){
            console.log(response.data.message)
            toast.info(response.data.message);
          }

          let objectDocument = {
            userId: localStorage.getItem('userId'),
            userType: 'specialist'
          }
          axios
          .post(api.GET_SPECIALIST_DOCUMENT_TYPE, objectDocument, {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + localStorage.token
            }
          })
          .then(function(response2) {
            if (response2.data.code == 200) {
              response2.data.data.success = true;

              return dispatch({
                type: types.GET_SPECIALIST_DOCUMENT,
                specialistDocument: response2.data.data
              });
            } else {
              toast.error(response2.data.message);
              response2.data.data.success = false;
              return dispatch({
                type: types.GET_SPECIALIST_DOCUMENT,
                specialistDocument: response2.data.data ? response2.data.data : []
              });
            }
          })
          .catch(function(error) {
            console.log(error)
          });



          // return dispatch({
          //   type: types.UPLOAD_SPECIALIST_DOCUMENT,
          //   uploadedSpecialistData: response.data.data
          // });
        } else {
          if(i==(data.file.length-1)){

            toast.error(response.data.message);
          }
         
          response.data.data.success = false;
          return dispatch({
            type: types.UPLOAD_SPECIALIST_DOCUMENT,
            uploadedSpecialistData: response.data.data ? response.data.data : {}
          });
        }
      })
      .catch(function(error) {});

  

    }

   
  };
}
export function getSpecialistDocument(data, props) {
  return function(dispatch, getState) {
    axios
      .post(api.GET_SPECIALIST_DOCUMENT_TYPE, data, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.token
        }
      })
      .then(function(response) {
        if (response.data.code == 200) {
          response.data.data.success = true;
          if (response.data.data.totalCount > 0) {
						localStorage.setItem('isDocumentUploaded', false);
					}else {
						localStorage.setItem('isDocumentUploaded', true);
          }
          return dispatch({
            type: types.GET_SPECIALIST_DOCUMENT,
            specialistDocument: response.data.data
          });
        } else {
          toast.error(response.data.message);
          response.data.data.success = false;
          return dispatch({
            type: types.GET_SPECIALIST_DOCUMENT,
            specialistDocument: response.data.data ? response.data.data : []
          });
        }
      })
      .catch(function(error) {
        console.log(error)
      });
  };
}


export function getSpecialistDocumentAndStatus(){


	return function(dispatch, getState){

		let dataObj = {
			userId: localStorage.getItem('userId')
		}
		axios.post(api.GET_SPECIALIST_DOCUMENT_AND_STATUS,dataObj, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
		.then(function(response){
      console.log('status',response)
      return dispatch({
        type: types.GET_SPECIALIST_DOCUMENT_AND_STATUS,
        docAndStatus: response.data.data ? response.data.data : {}
      });
		})
		.catch(function(error){
			console.log(error)
		});

		
	}
}




export function deleteSpecialistDocument(objectDocument, documentId) {
  return function(dispatch, getState) {
    var data = {
      documentId: documentId
    };
    axios
      .post(
        api.DELETE_SPECIALIST_DOCUMENT,
        { documentId: documentId },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.token
          }
        }
      )
      .then(function(response) {
        if (response.data.code == 200) {
          toast.info(response.data.message);
          axios
            .post(api.GET_SPECIALIST_DOCUMENT, objectDocument, {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + localStorage.token
              }
            })
            .then(function(response) {
              if (response.data.code == 200) {
                response.data.data.success = true;
                return dispatch({
                  type: types.GET_SPECIALIST_DOCUMENT,
                  specialistDocument: response.data.data
                });
              } else {
                toast.error(response.data.message);
                response.data.data.success = false;
                return dispatch({
                  type: types.GET_SPECIALIST_DOCUMENT,
                  specialistDocument: response.data.data
                });
              }
            })
            .catch(function(error) {});
        } else {
        }
      })
      .catch(function(error) {});
  };
}

export function getSpecialistDocumentById(documentId) {
  return function(dispatch, getState) {
    axios
      .post(
        api.GET_SPECIALIST_DOCUMENT_BY_ID,
        { documentId: documentId },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.token
          }
        }
      )
      .then(function(response) {
        if (response.data.code == 200) {
          response.data.data.success = true;
          return dispatch({
            type: types.GET_SPECIALIST_DOCUMENT_BY_ID,
            specialistDocumentData: response.data.data
          });
        } else {
          toast.error(response.data.message);
          response.data.data.success = false;
          return dispatch({
            type: types.GET_SPECIALIST_DOCUMENT_BY_ID,
            specialistDocumentData: response.data.data
          });
        }
      })
      .catch(function(error) {});
  };
}

export function updateDocumentStatus(data, props) {
  return function(dispatch, getState) {
    axios
      .post(api.UPDATE_DOCUMENT_STATUS, data, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.token
        }
      })
      .then(function(response) {
        if (response.data.code == 200) {
          axios
            .post(api.GET_SPECIALIST_DOCUMENT, data, {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + localStorage.token
              }
            })
            .then(function(response) {
              if (response.data.code == 200) {
                response.data.data.success = true;
                return dispatch({
                  type: types.GET_SPECIALIST_DOCUMENT,
                  specialistDocument: response.data.data
                });
              } else {
                toast.error(response.data.message);
                response.data.data.success = false;
                return dispatch({
                  type: types.GET_SPECIALIST_DOCUMENT,
                  specialistDocument: response.data.data
                    ? response.data.data
                    : []
                });
              }
            })
            .catch(function(error) {});
        } else if (response.data.code == 402) {
          localStorage.clear();
          props.history.push("/");
          toastr.error(response.data.message);
        }
      })
      .catch(function(error) {});
  };
}

export function submitForVerification(data, props) {
  return function(dispatch, getState) {
    axios
      .post(api.SUBMIT_DOCUMENT_FOR_VERIFICATION, data, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.token
        }
      })
      .then(function(response) {
        if (response.data.code == 200) {
          toastr.success(response.data.message);
        } else if (response.data.code == 402) {
          localStorage.clear();
          props.history.push("/");
        }
      })
      .catch(function(error) {});
  };
}

export function setDocumentExpiryDate(data, props) {
  return function(dispatch, getState) {
    axios
      .post(api.SET_DOCUMENT_EXPIRY_DATE, data, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.token
        }
      })
      .then(function(response) {
        if (response.data.code == 200) {
          let objectDocument = {
            page: 1,
            count: 10,
            userId: props.match.params.specialistId
          }
        props.actions.getSpecialistDocument(objectDocument);
          toast.success(response.data.message);
        } else if (response.data.code == 402) {
          localStorage.clear();
          props.history.push("/");
        }
      })
      .catch(function(error) {});
  };
}



